import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

const ToolBarPortal = ({ children, style = {} }) => {
  const elRef = useRef(null);
  if (!elRef.current) {
    elRef.current = document.createElement('div');
  }

  React.useEffect(() => {
    const el = elRef.current;
    Object.assign(el.style, {
      position: 'fixed',
      zIndex: 12,
      pointerEvents: 'auto',
      ...style,
    });
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, [style]);

  return ReactDOM.createPortal(children, elRef.current);
};

export default ToolBarPortal;
